import { Component, EventEmitter, Output, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { ContentLanguage } from '@coin/shared/core/util-enums';
import { CommunicationContent, Topic } from '@coin/shared/core/util-models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'coin-c-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MaintenanceBannerComponent {
  private translateService = inject(TranslateService);

  readonly topic = input<Topic>(undefined);
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  get languageContent(): CommunicationContent {
    const foundContent: CommunicationContent = this.topic()?.contents?.find(
      content => content.language === this.translateService?.currentLang
    );
    return foundContent || this.topic()?.contents?.find(content => content.language === ContentLanguage.ENGLISH);
  }

  onClose(): void {
    this.close.emit();
  }
}
